import { createContext, useContext } from 'react';

interface IntercomContextValue {
  openIntercom: () => void;
}

export const IntercomContext = createContext<IntercomContextValue | null>(null);

export const useIntercomContext = () => {
  const context = useContext(IntercomContext);
  if (!context) {
    // Return a no-op function instead of throwing
    // This handles cases where the hook is called before provider is ready
    return {
      openIntercom: () => {
        console.warn('Intercom is not initialized yet');
      },
    };
  }
  return context;
};
